import { LazyMotion, m } from 'framer-motion'

// ----------------------------------------------------------------------

const loadFeatures = async () => (await import('./features.js')).default

interface Props {
  children: React.ReactNode
}

function MotionLazy ({ children }: Props) {
  return (
    <LazyMotion features={loadFeatures} strict>
      <m.div style={{ height: '100%' }}> {children} </m.div>
    </LazyMotion>
  )
}

export default MotionLazy
